// ============================================================
// PORTAL BRAND — the single source of truth for the product's brand tokens
// (name, wordmark halves, tagline, engine display name). Extracted verbatim
// from the monolith (legacy/App.tsx) so src/ views can read the brand WITHOUT
// reaching into the monolith. The monolith imports PORTAL_BRAND from here too
// (one source, no fork). The code name of the engine stays Padel24Engine;
// `engineName` is only the *displayed* name.
// ============================================================
export const PORTAL_BRAND = {
  name: 'Starpoint', // fullt navn i tekst
  wordmarkA: 'star', // første del av logo (mørk)
  wordmarkB: 'point', // andre del av logo (lime aksent)
  tagline: 'Padel Portal',
  engineName: 'Starpoint Engine', // synlig navn på motoren (kode heter Padel24Engine)
  // Support contact shown on a Banepad that has lost its connection (public
  // info, not a secret). Empty strings hide the line — fill in when known.
  support: { phone: '', email: '' },
};
